<template>
    <div>
        <div
            v-if="!!error"
            class="mt-3 p-3 border border-theme-danger text-theme-danger rounded-lg text-sm"
            role="alert"
        >
            ⚠️ {{ error }}
        </div>
        <div class="flex justify-center mt-4">
            <label
                class="w-full max-w-lg flex flex-col items-center justify-center px-6 py-10 border-2 border-dashed rounded-xl cursor-pointer transition-colors"
                :class="
                    isLoading
                        ? 'opacity-80 cursor-not-allowed border-theme-disabled'
                        : selectedFile
                        ? 'border-theme-success bg-theme-hover'
                        : 'border-theme-success hover:bg-theme-hover'
                "
            >
                <img
                    src="@/assets/images/upload.svg"
                    height="48"
                    width="48"
                    alt="upload file"
                    class="mb-3 opacity-70"
                />
                <span
                    v-if="!selectedFile && !isLoading"
                    class="text-base font-semibold text-theme-success text-center"
                >
                    Haz clic aquí para seleccionar el archivo Excel
                </span>
                <span
                    v-else-if="isLoading"
                    class="text-base font-semibold text-theme-warning text-center"
                >
                    ⏳ Procesando archivo...
                </span>
                <span
                    v-else
                    class="text-base font-semibold text-theme-success text-center"
                >
                    ✅ {{ file.name }}
                </span>
                <span class="mt-2 text-sm text-theme-muted">
                    .xlsx — máx. 20 MB
                </span>
                <input
                    id="application-uploader"
                    :disabled="isLoading"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv,.xls"
                    autocomplete="off"
                    tabindex="-1"
                    multiple=""
                    data-testid="file-drop-massive-load"
                    class="hidden"
                    @input="uploadButton($event)"
                />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "MassiveFileLoader",
    props: {
        parser: {
            type: Function,
            required: true
        },
        templatePath: {
            type: String,
            default: ""
        }
    },
    emits: ["loaded", "loading", "error"],
    data: () => ({
        isLoading: false,
        selectedFile: false,
        file: { name: "" },
        error: ""
    }),
    methods: {
        async uploadButton(event) {
            const auxFile = event.target.files || event.dataTransfer.files;
            if (!auxFile.length) return;
            this.file = auxFile[0];
            const fileSize = this.file.size / 1048576;
            if (fileSize > 40) {
                this.error = "Archivo demasiado pesado máximo 40 MB";
                return;
            }
            this.selectedFile = true;
            this.error = "";
            try {
                this.$emit("loading");
                const rows = await this.parser(this.file);
                this.$emit("loaded", rows);
            } catch {
                this.$emit("error");
                this.error =
                    "Ha ocurrido un error transformando el archivo, descargue el archivo base oficial, recargue la página e inténtelo nuevamente.";
            }
        }
    }
};
</script>
